import {
  pgTable,
  text,
  timestamp,
  uuid,
  integer,
  boolean,
  index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Scheduled Triggers — Cron-based workflow triggers (F4)
// ---------------------------------------------------------------------------
// The cron Worker (C.8) evaluates: SELECT * FROM scheduled_triggers
// WHERE is_active = true AND next_fire_at <= NOW() ORDER BY next_fire_at LIMIT 100.
// AC1: Index on (isActive, nextFireAt) is CRITICAL for this query.

export const scheduledTriggers = pgTable("scheduled_triggers", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  // CQ3: text (not uuid) — references workflow ID in KV definition store or DB
  workflowId: text("workflow_id").notNull(), // References workflow ID (DB uuid or KV definition key)
  name: text("name").notNull(),
  cronExpression: text("cron_expression").notNull(), // Standard cron format: "0 9 * * 1"
  timezone: text("timezone").notNull().default("UTC"),
  isActive: boolean("is_active").notNull().default(true),
  lastFiredAt: timestamp("last_fired_at", tz),
  nextFireAt: timestamp("next_fire_at", tz),
  maxExecutions: integer("max_executions"), // Nullable = unlimited
  executionCount: integer("execution_count").notNull().default(0),
  createdBy: uuid("created_by"),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_sched_trig_tenant").on(table.tenantId),
  // AC1: Critical index for cron scan — must be fast at 300K tenants
  index("idx_sched_trig_active_next").on(table.isActive, table.nextFireAt),
  index("idx_sched_trig_workflow").on(table.tenantId, table.workflowId),
]);
